import { render, staticRenderFns } from "./tieziInfo.vue?vue&type=template&id=4cd9b55d&scoped=true"
import script from "./tieziInfo.vue?vue&type=script&lang=js"
export * from "./tieziInfo.vue?vue&type=script&lang=js"
import style0 from "./tieziInfo.vue?vue&type=style&index=0&id=4cd9b55d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd9b55d",
  null
  
)

export default component.exports